import dynamic from "next/dynamic";

export const SectorTeam = dynamic(() => import("./component"));
